(function () {
  if (window.matchMedia('(pointer: coarse)').matches) return;
  document.querySelectorAll('[data-ed-marquee]').forEach((el) => {
    let raf;
    const onMove = (e) => {
      const r = el.getBoundingClientRect();
      const dy = Math.min(Math.abs(e.clientY - (r.top + r.height / 2)) / (r.height * 1.5), 1);
      const speed = 0.2 + (1 - dy) * 0.5;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => el.style.setProperty('--ed-marquee-speed', speed));
    };
    const onLeave = () => el.style.setProperty('--ed-marquee-speed', 0.55);
    el.addEventListener('pointermove', onMove);
    el.addEventListener('pointerleave', onLeave);
  });
})();
